import type { Copro } from './Copro';
import type { User } from './User';

export enum AttributionRole {
  REFERENT = 'referent',
  ASSISTANT_REFERENT = 'assistant-referent',
  GESTIONNAIRE = 'gestionnaire-immeuble',
  ASSISTANT_GESTIONNAIRE = 'assistant-gestionnaire-immeuble',
  TRANSACTIONNAIRE = 'transactionnaire',
  GESTIONNAIRE_LOCATIF = 'gestionnaire-locatif',
  INTERVENANT = 'intervenant-exterieur',
}

export const AttributionRoleLabels: Record<AttributionRole, string> = {
  [AttributionRole.REFERENT]: 'RÉFÉRENT PUBLIQUE',
  [AttributionRole.ASSISTANT_REFERENT]: 'CHARGÉ QUALIF DPE',
  [AttributionRole.GESTIONNAIRE]: 'GESTIONNAIRE DE L\'IMMEUBLE',
  [AttributionRole.ASSISTANT_GESTIONNAIRE]: 'RESPONSABLE DU DOCUMENT D\'AG',
  [AttributionRole.TRANSACTIONNAIRE]: 'TRANSACTIONNAIRE',
  [AttributionRole.GESTIONNAIRE_LOCATIF]: 'GESTIONNAIRE LOCATIF',
  [AttributionRole.INTERVENANT]: 'INTERVENANT EXTÉRIEUR',
};

export interface Pagination {
  totalResults: number;
  totalPages: number;
  itemsPerPage: number;
  currentPage: number;
  previousPage: number | null;
  nextPage: number | null;
}

export interface CoproUserAttribution {
  id: number;
  user: User;
  copro: Copro;
  fonctionType: AttributionRole;
  toNotifyForNewDPE: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CoproUserAttributionResponse {
  pagination: Pagination;
  results: CoproUserAttribution[];
}

export const getRoleLabel = (role: AttributionRole): string => {
  return AttributionRoleLabels[role] || 'Unknown Role';
};

// An external intervener belongs to a subcontractor, whose collaborators handle both meetings.
export const isSellManager = (attribution: CoproUserAttribution): boolean => {
  return attribution.fonctionType === AttributionRole.TRANSACTIONNAIRE
    || attribution.fonctionType === AttributionRole.INTERVENANT;
};

export const isRentManager = (attribution: CoproUserAttribution): boolean => {
  return attribution.fonctionType === AttributionRole.GESTIONNAIRE_LOCATIF
    || attribution.fonctionType === AttributionRole.INTERVENANT;
}; 